import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { ConstantService } from '../../components/common/utils/constant.service';
import { Siniestros, SiniestralidadSiniestros } from '../../components/common/siniestros_entity';
import { ClienteResumen } from '../login/cliente_login';
import { DatosSiniestro, MensajeSiniestro, MensajeCampoValor } from './siniestroscorporativos_entity';


@Injectable()
export class SiniestroscorporativoService {
    private url = "utils";

    constructor(public authHttp: AuthHttp) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    ConsultarSiniestros(cliente: ClienteResumen): Observable<Siniestros> {
        let body = JSON.stringify(cliente);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/GetSiniestroscorporativos", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    ConsultarSiniestralidadSiniestros(cliente: ClienteResumen): Observable<SiniestralidadSiniestros[]> {
        let body = JSON.stringify(cliente);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/GetSiniestralidadSiniestros", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    ConsultaTrackingVehiculos(codigo: number): Observable<object>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/getTrackingVehiculo/"+ codigo, options).map(this.extractData)
            .catch(this.handleError);
    }
    ConsultaTrackingOtrosRamos(codigo: number): Observable<object>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/getTrackingOtrosRamos/"+ codigo, options).map(this.extractData)
            .catch(this.handleError);
    }
    ConsultaTrackingAsistencia(codigo: number): Observable<object>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/getTrackingAsistencia/"+ codigo, options).map(this.extractData)
            .catch(this.handleError);
    }
    ReportarSiniestroVehiculos(siniestro: DatosSiniestro): Observable<MensajeSiniestro> {
        let body = JSON.stringify(siniestro);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/reportarSiniestrosVehiculos", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    ReportarSiniestroOtrosRamos(siniestro: DatosSiniestro): Observable<MensajeSiniestro> {
        let body = JSON.stringify(siniestro);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/reportarSiniestroOtrosRamos", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    DetalleDeducible(codigo: number): Observable<object>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/Deducible/"+ codigo, options).map(this.extractData)
            .catch(this.handleError);
    }
    DetalleRcs(codigo: number): Observable<MensajeCampoValor[]>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/RC/"+ codigo, options).map(this.extractData)
            .catch(this.handleError);
    }


    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/siniestroscorporativos/siniestroscorporativo.service.ts